import Footer from 'modules/common/components/footer';
import Navbar from 'modules/common/components/navbar';

export default function FAQGasPage() {
  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
      </div>
      <div className='relative py-16 bg-black overflow-hidden'>
        <div className='relative px-4 sm:px-6 lg:px-8'>
          <div className='text-lg max-w-screen-lg mx-auto'>
            <h1>
              <span className='block text-base text-center text-[#00ce1b] font-semibold tracking-wide uppercase'>
                Gas fees
              </span>
              <span className='mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-white sm:text-4xl'>
                What are gas fees?
              </span>
            </h1>
            <p className='mt-8 text-xl text-gray-300 leading-8'>
              In web3, the term{' '}
              <a
                href='bit.ly/greenartcoin-gas-fees'
                className='text-gray-50 font-medium'
              >
                “gas fee”
              </a>{' '}
              refers to the payment needed to execute transactions on the
              blockchain. These payments compensate the
              <a
                href='https://ethereum.org/en/run-a-node/'
                className='text-gray-50 font-medium'
              >
                {' '}
                node operators
              </a>{' '}
              who keep the blockchain functioning. This validation helps ensure
              the blockchain has a permanent, immutable record
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
